const stepperData = [
  "施設選択",
  "対象施設一覧/解除内容入力",
  "入力内容確認",
  "機構へ提出",
];

const headList = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設区分",
  },
  {
    headTitle: "解除年月日",
  },
  {
    headTitle: "部分解除の人数",
  },
  {
    headTitle: "解除同意書",
  },
  {
    headTitle: "解除理由",
  },
];

export { stepperData, headList };
